import { render, staticRenderFns } from "./cpt-image.vue?vue&type=template&id=2ac53678&scoped=true"
import script from "./cpt-image.vue?vue&type=script&lang=js"
export * from "./cpt-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac53678",
  null
  
)

export default component.exports